import { useCallback } from 'react';

import { client, useFormErrorHandler } from 'core/http';
import { CustomerSchema } from 'core/schemas/customer';
import { Customer } from 'core/types/customer';

export default function useCustomerCreates() {
  const handleFormErrors = useFormErrorHandler();

  return useCallback((payload: CustomerSchema) => {
    return client()
      .post<Customer>(`customers`, payload)
      .then(response => response.data)
      .catch(handleFormErrors);
  }, [handleFormErrors]);
}
